import React from "react";
import { connect } from "react-redux";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import PermIdentity from "@material-ui/icons/PermIdentity";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Clearfix from "components/Clearfix/Clearfix.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardAvatar from "components/Card/CardAvatar.jsx";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Datetime from "react-datetime";
import Axios from "axios";
import { pushProfilewlist, proccessUpload } from "api/Profile/index";
import { pushLoader } from "actions/main";
import avatar from "../../assets/img/faces/no-profile.png";
import ImageUpload from "components/CustomUpload/ImageUpload.jsx";
import ImageUploader from "react-images-upload";

import moment from "moment";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";
import Config from "../../config/";
import { withRouter } from "react-router-dom";
const ROOT_URL = Config.rooturl;

class UserprofileCrud extends React.Component {
  constructor(props) {
    super(props);

    console.log(this.props);

    this.state = {
      name: this.props.datanya["name"],
      id: this.props.datanya["id"],
      token: localStorage.getItem("token"),
      picture_url: this.props.datanya["picture_url"],
      profile: "",
      job: this.props.datanya["job"],
      description: this.props.datanya["description"],
      email: this.props.datanya["email"],
      multipleSelect: [],
      simpleSelect: this.props.datanya["gender"],
      userlevel: this.props.datanya["userlevel"],
      brithday: moment(this.props.datanya["brithday"]),
      gender: this.props.datanya["gender"],

      pictures: [],
      file_upload: "",
      msgerror: ""
    };
  }

  UNSAFE_componentWillMount() {
    console.log(this.state.datanya);
    this.props.pushLoader(false);
    console.log("=========");
    console.log(this.state.picture_url);
    if (this.state.picture_url == "") {
      this.setState({ picture_url: avatar });
    }
    console.log("==========");
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    console.log(nextProps);
  }

  onDrop = picture => {
    this.setState({
      pictures: this.state.pictures.concat(picture)
    });
  };

  handleMultiple = event => {
    console.log(event.target.value);
    this.setState({ multipleSelect: event.target.value });
  };

  handleSimple = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  getBirthday = event => {
    console.log(moment(event._d, "YYYY MMMM DD").format("YYYY-MM-DD"));
    this.setState({ brithday: moment(event._d) });
  };

  handleChangeName = e => {
    console.log({ name: e.target.value });
    this.setState({ name: e.target.value });
  };

  handleChangeJob = e => {
    this.setState({ job: e.target.value });
  };

  handleChangeDescription = e => {
    this.setState({ description: e.target.value });
  };

  handleFileUpload = event => {
    this.setState({ file_upload: event.target.files[0] });
    console.log(event.target.files[0]);
  };

  handleUpdateProfile = () => {
    let picture_url = "";

    console.log(this.state.file_upload);

    this.setState({ msgerror: "" });

    let pass = "";
    // if (this.state.password != "") {
    //   if (this.state.password == this.state.passwordcheck) {
    //     pass = this.state.password;
    //   } else {
    //     pass = "";
    //
    //     this.setState({msgerror: "password not match!"})
    //     return false;
    //   }
    // }else{
    //   pass = "";
    //
    //   this.setState({msgerror: "password not match!"});
    //   return false;
    // }

    let urlupload;

    // if (this.state.file_upload != "") {
    //   proccessUpload(this.state.file_upload)
    //     .then(response => {
    //       picture_url = response.data.url;
    pushProfilewlist(
      this.state.id,
      this.state.email,
      this.state.name,
      this.state.gender,
      moment(this.state.brithday, "YYYY MMMM DD").format("YYYY-MM-DD"),
      this.state.description,
      this.state.job,
      this.state.userlevel,
      picture_url
    )
      .then(response => {
        if (response != null) {
          console.log("berhasil");
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        window.location.replace(document.referrer);
      });
    //     })
    //     .catch(error => {
    //       console.log(error);
    //       this.props.history.push("/pages/login#logout");
    //     });
    // } else {
    //   pushProfilewlist(
    //     this.state.id,
    //     this.state.email,
    //     this.state.name,
    //     this.state.gender,
    //     moment(this.state.brithday, "YYYY MMMM DD").format("YYYY-MM-DD"),
    //     this.state.description,
    //     this.state.job,
    //     this.state.userlevel,
    //     picture_url
    //   )
    //     .then(response => {
    //       if (response != null) {
    //         console.log("berhasil");
    //       }
    //     })
    //     .catch(error => {
    //       console.log("tidak berhasil");
    //       this.props.history.push("/pages/login#logout");
    //     });
    // }
  };

  handleUpdatePassword = () => {
    const data = {
      name: this.state.name,
      email: this.state.email,
      gender: this.state.gender,
      brithday: moment(this.state.brithday, "YYYY MMMM DD").format(
        "YYYY-MM-DD"
      ),
      description: this.state.description,
      job: this.state.job
    };
    console.log(
      moment(this.state.brithday, "YYYY MMMM DD").format("YYYY-MM-DD")
    );
    pushProfilewlist(
      this.state.id,
      this.state.email,
      this.state.name,
      this.state.gender,
      moment(this.state.brithday, "YYYY MMMM DD").format("YYYY-MM-DD"),
      this.state.description,
      this.state.job,
      this.state.userlevel
    )
      .then(response => {
        if (response != null) {
          console.log("berhasil");
        }
      })
      .catch(error => {
        console.log("tidak berhasil");
        this.props.history.push("/pages/login#logout");
      });
  };

  handleChangePassword = event => {
    this.setState({ password: event.target.value });
  };

  handleChangePasswordCheck = event => {
    this.setState({ passwordcheck: event.target.value });
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <PermIdentity />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>
                  Edit User - <small>Complete your profile</small>
                </h4>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  {/*<GridItem xs={12} sm={12} md={5}>
                    <CustomInput
                      labelText="Company (disabled)"
                      id="company-disabled"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        disabled: true
                      }}
                    />
                  </GridItem>*/}
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="Email address"
                      id="email-address"
                      inputProps={{
                        value: this.state.email
                      }}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <CustomInput
                      labelText="name"
                      inputProps={{
                        value: this.state.name,
                        onChange: this.handleChangeName
                      }}
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        Choose Gender
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={this.state.simpleSelect}
                        onChange={this.handleSimple}
                        inputProps={{
                          name: "simpleSelect",
                          id: "simple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem
                          }}
                        >
                          Choose Gender
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="male"
                        >
                          Male
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="female"
                        >
                          Female
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor="simple-select"
                        className={classes.selectLabel}
                      >
                        Choose User Level
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu
                        }}
                        classes={{
                          select: classes.select
                        }}
                        value={this.state.userlevel}
                        onChange={this.handleSimple}
                        inputProps={{
                          name: "userlevel",
                          id: "simple-select"
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem
                          }}
                        >
                          Choose User Level
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="0"
                        >
                          Programmer
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="3"
                        >
                          Guest
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected
                          }}
                          value="2"
                        >
                          Super User
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </GridItem>
                  {/* <GridItem xs={12} sm={12} md={12}>
                    <InputLabel className={classes.label}>
                      Date Picker
                    </InputLabel>
                    <br />
                    <FormControl fullWidth>
                      <Datetime
                        timeFormat={false}
                        dateFormat="LL"
                        onChange={this.getBirthday}
                        inputProps={{
                          placeholder: "Date Picker Here"
                        }}
                        value={this.state.brithday}
                      />
                    </FormControl>
                  </GridItem> */}
                </GridContainer>
                {/* <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <InputLabel style={{ color: "#AAAAAA" }}>
                      About me
                    </InputLabel>
                    <CustomInput
                      labelText="description"
                      id="about-me"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 5,
                        value: this.state.description,
                        onChange: this.handleChangeDescription
                      }}
                    />
                  </GridItem>
                </GridContainer> */}
                {/*}<GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Change Password"
                      inputProps={{
                        type: "password",
                        value: this.state.password,
                        onChange: this.handleChangePassword
                      }}
                      id="password"
                      formControlProps={{
                        fullWidth: true
                      }}

                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Confirm Password"
                      inputProps={{
                        type: "password",
                        value: this.state.passwordcheck,
                        onChange: this.handleChangePasswordCheck
                      }}
                      id="password"
                      formControlProps={{
                        fullWidth: true
                      }}

                    />
                  </GridItem>
                </GridContainer>*/}
                <font color="red">{this.state.msgerror}</font>
                <Button
                  color="rose"
                  className={classes.updateProfileButton}
                  onClick={this.handleUpdateProfile}
                >
                  Update Profile
                </Button>
                <Clearfix />
              </CardBody>
            </Card>
          </GridItem>
          {/* <GridItem xs={12} sm={12} md={4}>
            <Card profile>
              <CardBody profile>

              <CardAvatar profile>
                <a href="#pablo" onClick={e => e.preventDefault()}>
                  <img src={this.state.picture_url} alt="..." />
                </a>
              </CardAvatar>

              <Button variant="contained" component="label">
                <CustomInput
                  inputProps={{
                    type: "file",
                    onChange: this.handleFileUpload
                  }}
                />
              </Button> */}

          {/* <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6> */}
          {/* <CustomInput
                  labelText="job"
                  className={classes.cardCategory}
                  inputProps={{
                    value: this.state.job,
                    onChange: this.handleChangeJob
                  }}
                  id="job"
                  formControlProps={{
                    fullWidth: true
                  }}
                />
                <h4 className={classes.cardTitle}>{this.state.name}</h4>
                <p className={classes.description} />
              </CardBody>
            </Card>
          </GridItem> */}
        </GridContainer>
      </div>
    );
  }
}

UserprofileCrud.propTypes = {
  pushLoader
};

function mapStateToProps(state) {
  return {
    blocking: state.loader
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    { pushLoader }
  )(withStyles(userProfileStyles)(UserprofileCrud))
);
